import React from "react";
import { connect } from "react-redux";

/**
 */
class BemVindo extends React.Component {
  state = {
    empresa: "",
    mostraModal: false,
    cod_usuario: this.props.usuario.cod_usuario,
  };

  render() {
    return (
      <div className="h-100">
        <div
          style={{
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "5px",
          }}
        >
          <div style={{ textAlign: "center" }}>
            <img
              style={{ width: "auto", height: "60vh" }}
              src={
                this.props.empresa.cod_empresa_usuario
                  ? this.props.empresa.imagens.img_inicio
                  : ""
              }
              alt="Imagem BemVindo"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    usuario: state.usuario,
    empresa: state.empresa,
  }),
  (dispatch) => ({
    dispatch,
  })
)(BemVindo);



// WEBPACK FOOTER //
// ./src/lib_react_frontend/componentes/BemVindo.jsx